import type {ReactElement} from 'react';
import {useState} from 'react';

import {Button} from '@/components';
import type {AfriexReferralTier} from '@/types';

import EventTierFormModal from './EventTierFormModal';

type EventTierUpdateButtonProps = {
  initialData?: AfriexReferralTier;
};

const EventTierUpdateButton = ({
  initialData,
}: EventTierUpdateButtonProps): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  const label = initialData ? 'Update Event Tier' : 'Create Event Tier +';

  return (
    <>
      <Button
        onClick={() => setIsOpen(true)}
        variant="solid"
        colorScheme="cyan"
      >
        {label}
      </Button>
      <EventTierFormModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        data={initialData}
      />
    </>
  );
};

export default EventTierUpdateButton;
